import React from 'react'
import { toast } from 'libs/toast'
import { Form, Input } from 'semantic-ui-react'

export default function CyclrWebhookSetting({ webhookUrl, isDisabled }) {
  function copyTextToclipBoard(event) {
    event.preventDefault()

    if (isDisabled) {
      return
    }

    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(webhookUrl)
      toast.success('Boom! Webhook URL copied to clipboard.')
    } else {
      toast.error('The Webhook URL is not available.')
    }
  }

  return (
    <React.Fragment>
      <Form className="mt-4">
        <Form.Group grouped>
          <label>Webhook URL</label>
          <Form.Field>
            <Input
              style={{ width: 440 }}
              action={{
                icon: 'far fa-clone',
                onClick: (event) => copyTextToclipBoard(event)
              }}
              value={webhookUrl}
              disabled={isDisabled}
              readOnly
            />
          </Form.Field>
        </Form.Group>
      </Form>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/CyclrWebhookSetting/index.js